var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":"/gltf"}},[_c('a',[_vm._v("/GLTF Example")])]),_c('br'),_c('router-link',{attrs:{"to":"/obj"}},[_c('a',[_vm._v("/OBJ Example")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }